import { QuestionConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection";

import { useOptionPlanConnection } from "./hooks";

export const QuestionOptionPlanConnection = () => {
	const { availableItemIDs, rawAvailableItemIDs, onSetAvailableItemIDs, nameAndIDOptions } =
		useOptionPlanConnection();

	return (
		<QuestionConnection
			title="販売可能なプラン"
			availableItemIDs={availableItemIDs}
			rawAvailableItemIDs={rawAvailableItemIDs}
			onSetAvailableItemIDs={onSetAvailableItemIDs}
			nameAndIDOptions={nameAndIDOptions}
		/>
	);
};

QuestionOptionPlanConnection.displayName = "QuestionOptionPlanConnection";
